import React from 'react'

import DownloadButton from 'components/DownloadButton'
import { H2, Paragraph } from 'components/Styled/Typography'
import { breakpoints } from 'common/styles'
import IconUsers from './IconUsers'
import IconStar from './IconStar'
import IconMessages from './IconMessages'

import ImageDevice from './assets/zoe-web-samsung.jpg'
import ImageDevice2x from './assets/zoe-web-samsung@2x.jpg'
import ImageDevice3x from './assets/zoe-web-samsung@3x.jpg'

import ImageDeviceArm from './assets/zoe-web-arm.jpg'
import ImageDeviceArm2x from './assets/zoe-web-arm@2x.jpg'
import ImageDeviceArm3x from './assets/zoe-web-arm@3x.jpg'

import { Section, MainImage, Container, Content, Buttons, Numbers, NumbersItem } from './styled'

class HomepageAbout extends React.Component {
  scroll = () => {
    document.getElementById('about').scrollIntoView({ behavior: 'smooth' })
  }

  render() {
    return (
      <Section id="about">
        <Container>
          <Content>
            <MainImage>
              <source srcSet={`${ImageDevice2x} 2x, ${ImageDevice3x} 3x`}
                media={`(min-width: ${breakpoints.medium}px)`} />
              <source src={ImageDeviceArm} srcSet={`${ImageDeviceArm2x} 2x, ${ImageDeviceArm3x} 3x`}
                media={`(max-width: ${breakpoints.medium}px)`} />
              <img src={ImageDevice} alt="Zoe app" />
            </MainImage>

            <div>
              <H2 large>About Zoe</H2>
              <Paragraph large>It's simple. Swipe right if you like her, left to pass or&nbsp;send pre match message. Now let destiny take care of the rest. Don’t worry, it will be just a matter of time before you match with someone.</Paragraph>

              <Numbers>
                <NumbersItem>
                  <IconUsers />
                  <h3>3.5M+ <span>registred users</span></h3>
                </NumbersItem>
                <NumbersItem>
                  <IconStar />
                  <h3>4.9 <span>rating stars</span></h3>
                </NumbersItem>
                <NumbersItem>
                  <IconMessages />
                  <h3>10M <span>monthly <br />messages sent</span></h3>
                </NumbersItem>
              </Numbers>
            </div>
          </Content>

          <Buttons>
            <DownloadButton type="apple">App Store</DownloadButton>
            <DownloadButton type="google">Google Play</DownloadButton>
          </Buttons>
        </Container>
      </Section>
    )
  }
}

export default HomepageAbout
